import { maApiFetch } from './../api/apis'
import { saveAs } from 'file-saver'
import { createToast } from '@maui/elements'

export const notifyError = (title, message) => {
  createToast({
    variant: 'error',
    title,
    message,
  })
}

export const downloadError = (error) => {
  notifyError('Error downloading file', 'Unable to download your file. Please try again.')
  throw error
}

export const downloadFile = async (id, filename) => {
  try {
    const res = await maApiFetch(`/eod/attachments/mandiant/${id}`, {}, false)

    if (!res.ok) {
      downloadError(new Error('Unable to download your file. Please try again.'))
    }

    const blob = await res.blob()
    const data = URL.createObjectURL(blob)
    saveAs(data, filename)
  } catch (error) {
    downloadError(error)
  }
}
